import * as checked from 'reporting-data/lib/checked';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { FUNNEL } from '../../constants/visualizationTypes';
import { stepwiseConversionProperty, cumulativeConversionProperty
// @ts-expect-error Untyped import
} from './funnelConversionConstants';
export const Events = checked.record({
  onPointClick: checked.func().optional()
}, 'Events');
export const FunnelStyle = checked.record({
  tooltipFormatter: checked.func().optional()
}, 'FunnelStyle');
export const FunnelVisualization = checked.record({
  type: checked.string().always(FUNNEL),
  data: checked.map(Dataset),
  dataset: checked.string(),
  filterProperty: checked.string(),
  valueProperty: checked.string(),
  primaryChevronProperty: checked.string().defaultValue(stepwiseConversionProperty),
  secondaryChevronProperty: checked.string().defaultValue(cumulativeConversionProperty),
  // Switches to use a column chart to show the funnel horizontal
  horizontalFunnel: checked.boolean().defaultValue(false),
  // Indicates whether chevron conversion property relates to a row of data or
  // the relationship between rows of data. Impacts where chevron data renders.
  conversionDataInRow: checked.boolean().defaultValue(false),
  events: Events.optional(),
  disableZoom: checked.boolean().optional(),
  style: FunnelStyle.defaultValue({})
}, 'FunnelVisualization');